import { api } from '../../../api-helper';
import { URLS } from '../../../../constants/URLS';
export const sendActivityComments = (orderId, payload) => {
  return api.post(URLS.activityComments + `?id=${orderId}`, payload, {
    headers: {
      needsToken: true
    }
  });
};

export const getActivityComments = (
  orderId,
  filter,
  nextID = null,
  limit = 25
) => {
  let url =
    URLS.activityComments +
    `?id=${orderId}&filterBy=${encodeURIComponent(filter)}&limit=${limit}`;

  if (nextID) {
    url += `&page=${nextID}`;
  }

  return api.get(url, {
    headers: {
      needsToken: true
    }
  });
};

export const updateActivityData = (commentId, payload) => {
  return api.put(`${URLS.activityComments}?id=${commentId}`, payload, {
    headers: {
      needsToken: true
    }
  });
};

export const deleteActivityComment = (commentId) => {
  return api.delete(`${URLS.activityComments}?id=${commentId}`, {
    headers: {
      needsToken: true
    }
  });
};

export const toggleActivityEmailShare = (toggleData) => {
  return api.put(URLS.activityEmailShare, toggleData, {
    headers: {
      needsToken: true
    }
  });
};
